import { useState } from 'react';
import { BlogPostRenderer } from './BlogPostRenderer';
import './BlogPostView.scss';

function formatDatePL(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  return new Intl.DateTimeFormat('pl-PL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function BlogPostView({ post, isPreview = false }) {
  const [failedCoverSrc, setFailedCoverSrc] = useState(null);
  if (!post) return null;
  const showCover = post.cover_image_url && failedCoverSrc !== post.cover_image_url;

  return (
    <article className={`blog-post-view${isPreview ? ' blog-post-view--preview' : ''}`}>
      <header className="blog-post-view__header">
        <h1 className="blog-post-view__title">{post.title || 'Bez tytułu'}</h1>
        <div className="blog-post-view__meta">
          <span className="blog-post-view__author">{post.author_name || 'Magdalena Pawlak'}</span>
          {post.updated_at && (
            <>
              <span className="blog-post-view__meta-sep">&middot;</span>
              <time className="blog-post-view__date" dateTime={post.updated_at}>
                {formatDatePL(post.updated_at)}
              </time>
            </>
          )}
        </div>
      </header>

      {(post.excerpt || showCover) && (
        <div className={`blog-post-view__lead${post.excerpt ? '' : ' blog-post-view__lead--image-only'}`}>
          {post.excerpt && (
            <p className="blog-post-view__excerpt">{post.excerpt}</p>
          )}
          {showCover && (
            <div className="blog-post-view__cover">
              <img
                src={post.cover_image_url}
                alt={post.cover_image_alt || post.title || ''}
                className="blog-post-view__cover-img"
                onError={() => setFailedCoverSrc(post.cover_image_url)}
              />
            </div>
          )}
        </div>
      )}

      <div className="blog-post-view__body">
        {post.content_json ? (
          <BlogPostRenderer contentJson={post.content_json} />
        ) : (
          <p className="blog-post-view__empty">Brak treści.</p>
        )}
      </div>
    </article>
  );
}
